import { default as defaultData } from "./default.json";

const data: { [key: string]: object } = {
  default: defaultData,
};

const preferences = {
  get: () => data["default"],
  update: (values: any) => {
    const currentPreferences = data["default"] as any;
    currentPreferences.data.attributes.receive_weekly_summary =
      values.receive_weekly_summary;
    return currentPreferences;
  },
  updateProgram: (values: any) => {
    const currentPreferences = data["default"] as any;
    currentPreferences.included[0].attributes.can_send_emails =
      values.can_send_emails;
    return currentPreferences;
  },
};

export default preferences;
